/**
 * Get the radar slice holder
 *
 * @returns {HTMLElement} The element that holds the slices
 */
function getRadar() {
	return document.querySelector('.quiz__radar .radar__slice-wrap');
}

/**
 * Get the radar slice holder for the results radar
 * that is shown after all questions have been answered
 *
 * @returns {HTMLElement} The element that golds the slices
 */
function getResultRadar() {
	return document.querySelector('.quiz__result-radar .radar__slice-wrap');
}

/**
 * Get the radar slice holder for the results radar
 * that is shown after all questions have been answered
 *
 * @returns {HTMLElement} The element that golds the slices
 */
function getResultsPageRadar() {
	return document.querySelector('.results__result-radar .radar__slice-wrap');
}

/**
 *
 * @param {HTMLElement} radar Radar element
 * @param {Array} scoreArray The score array
 */
function showResultsRadar(radar, scoreArray) {
	let delay = 0;
	scoreArray.forEach((answerObj) => {
		delay++;
		const { answer, order } = answerObj;
		//const order = index;
		setRadarSlice(order, answer, radar);
		window.setTimeout(() => {
			radar.querySelector(`[data-order="${order}"]`).dataset.status =
				'answered';
		}, delay * 150);
	});
}

/**
 * Set the score (magnitude) of a radar slice
 *
 * @param {String} order The question this relates to
 * @param {Number} score The score
 * @param {HTMLElement} radar The element that holds the slices
 */
function setRadarSlice(order, score, radar) {
	const slice = radar.querySelector(`[data-order="${order}"]`);
	slice.dataset.score = score;
}

export {
	getRadar,
	getResultRadar,
	setRadarSlice,
	showResultsRadar,
	getResultsPageRadar,
};
